import React, { useEffect, useState } from 'react';
import { Divider, FormControlLabel, Radio, Theme, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { useTranslation } from 'react-i18next';
import { LayoutGrid, LayoutGridItem } from 'app/layout/LayoutGrid';
import { Controller, useFormContext } from 'react-hook-form';
import { FormInputText } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputText';
import { FormInputDropdown } from 'app/components/Candidate/CandidateProfile/CandidateTabPanel/PersonalInfoTab/Form/Controls/FormInputDropdown';
import { useSelector } from 'react-redux';
import {
  selectIslandsCancel,
  selectPlacementLandsGtgDetails,
} from '../../../../../../../store/redux-store/placement-details/selectors';
const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    // padding: '0px 10px',
  },
  alingmentField: {
    paddingLeft: '6px !important',
    paddingRight: '25px !important',
  },
  sectionTitle: {
    paddingBottom: '6px',
    paddingTop: '6px',
  },
  subTitleStyle: {
    fontWeight: 'bold',
  },
  alignItem: {
    paddingLeft: '18px !important',
  },
  itemStyle: {
    paddingTop: '22px !important',
    height: '90px',
  },
  itemStyleExceptionWaive: {
    height: '110px',
  },
}));
export const StateRequirements = props => {
  const { t } = useTranslation();
  const { classes } = useStyles();
  const selectiscancel = useSelector(selectIslandsCancel);
  const selectLandsGtgDetails = useSelector(selectPlacementLandsGtgDetails);
  const { formState: { errors }, getValues, setValue, clearErrors, control } = useFormContext();
  useEffect(() => {
    setValue('pReason', selectLandsGtgDetails?.checkStateReason);
    setValue(
      'piExWave',
      props.waveandexList?.find(x => x.Id === selectLandsGtgDetails?.checkStateExceptId?.toString())?.Description,
    );
    setValue('pYes', selectLandsGtgDetails?.checkState);
    setCurrentYes(selectLandsGtgDetails?.checkState || false);
    setCurrentNo(!selectLandsGtgDetails?.checkState || false);
  }, [props.waveandexList, selectLandsGtgDetails, selectiscancel, setValue]);
  const [currentYes, setCurrentYes] = useState<boolean>(selectLandsGtgDetails?.checkState || false);
  const [currentNo, setCurrentNo] = useState<boolean>(!selectLandsGtgDetails?.checkState || false);

  const handleIExWaveChange = event => {
    setValue('piExWave', event.target.value, { shouldDirty: true });
    props.handleFieldChanges?.();
  };
  const handleReasonChange = e => {
    setValue('pReason', e.target.value, { shouldDirty: true });
    props.handleFieldChanges?.();
  };

  return (
    <>
      <LayoutGrid container direction="column" className={classes.root} spacing={0}>
        <LayoutGridItem item className={classes.sectionTitle}>
          <Typography variant="subtitle1" component="div" className={classes.subTitleStyle}>
            {t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.StateRequirements')}
          </Typography>
        </LayoutGridItem>
        <Divider variant="middle" />
        <LayoutGridItem item className={`${classes.alignItem} ${classes.itemStyle}`}>
          <LayoutGrid
            container
            classes={{ root: classes.root }}
            direction="row"
            data-testid="container"
            justifyContent="flex-start"
            spacing={4}
          >
            <LayoutGridItem item xs={6} className={classes.alingmentField}>
              <Typography component="span">
                {t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.allItemsCheckOffStateLevelMessage')}
              </Typography>
              <LayoutGridItem>
                <Controller
                  name="pYes"
                  key={'yes'}
                  control={control}
                  render={({ field: { onChange, value, ...rest } }) => (
                    <FormControlLabel
                      name="pYes"
                      key={'yes'}
                      control={
                        <Radio
                          checked={currentYes}
                          disabled={!props.hasEditPermission}
                          onChange={e => {
                            setCurrentYes(!currentYes);
                            setCurrentNo(!currentNo);
                            setValue('pNo', false, { shouldDirty: true });
                            setValue('pYes', !currentYes, { shouldDirty: true });
                            clearErrors('pReason');
                            setValue('pReason', '', { shouldDirty: true });
                            props.handleFieldChanges?.();
                          }}
                        />
                      }
                      label={t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.allItemsCheckOffStateLevelYes')}
                    />
                  )}
                />
                <Controller
                  key={'no'}
                  name="pNo"
                  control={control}
                  render={({ field: { onChange, value, ...rest } }) => (
                    <FormControlLabel
                      key={'no'}
                      name="pNo"
                      control={
                        <Radio
                          checked={currentNo}
                          onChange={e => {
                            setCurrentNo(!currentNo);
                            setCurrentYes(!currentYes);
                            setValue('pNo', !currentNo, { shouldDirty: true });
                            setValue('pYes', false, { shouldDirty: true });
                            props.handleFieldChanges?.();
                          }}
                          disabled={!props.hasEditPermission}
                        />
                      }
                      label={t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.allItemsCheckOffStateLevelNo')}
                    />
                  )}
                />
              </LayoutGridItem>
            </LayoutGridItem>
            <LayoutGridItem item xs={6} className={classes.alingmentField}>
              <FormInputText
                name="pReason"
                readOnly={currentYes || !props.hasEditPermission}
                label={`${t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.hasEditNoPermission')} `}
                handleChange={handleReasonChange}
                require={false}
                message={errors['pReason']?.message || ''}
                inputValue={getValues('pReason')}
                isCheckBox={true}
              />
            </LayoutGridItem>
          </LayoutGrid>
        </LayoutGridItem>
        <LayoutGridItem item className={`${classes.alignItem} ${classes.itemStyleExceptionWaive}`}>
          <LayoutGrid
            container
            classes={{ root: classes.root }}
            direction="row"
            data-testid="container"
            justifyContent="flex-start"
            spacing={4}
          >
            <LayoutGridItem item xs={6} className={classes.alingmentField} data-testid={'exception-waive'}>
              <Typography variant="subtitle1" component="div">
                {`${t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.exceptionWaive')} ${t(
                  'placement.profile.tabs.LANDS/GTGTab.leftSideDetails.template',
                )}`}
              </Typography>
              <FormInputDropdown
                name={'piExWave'}
                label={t('placement.profile.tabs.LANDS/GTGTab.leftSideDetails.exceptionWaive')}
                require={false}
                options={props.waveandexList}
                handleChange={handleIExWaveChange}
                inputValue={
                  getValues('piExWave') !== undefined ? getValues('piExWave') : props.waveandexList[0]?.Description
                }
                readOnly={!props.hasEditPermission}
                isCheckBox={true}
              />
            </LayoutGridItem>
          </LayoutGrid>
        </LayoutGridItem>
      </LayoutGrid>
    </>
  );
};
